module.exports = __webpack_public_path__ + "static/media/treveoption2.0c1c2fc8.jpg";